// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__K0Y9T","brand":"Navbar_brand__lJZvs","links_list":"Navbar_links_list__N3mkF","active":"Navbar_active__j9xS-"};